import { GroupReadjustmentQuoeficient } from '../enums/readjustmentQuoeficient.enum';
import { FinesAndInterests } from '../enums/FinesAndInterests.enum';
import { GroupDivision } from '../enums/GroupDivision';
import { CivilStatus } from '../enums/CivilStatus';
import { ContractType } from '../enums/ContractType';
import { ContactType } from '../enums/ContactType';
import { ContractClassification } from '../enums/ContractClassification';
import { PaymentType } from '../enums/PaymentType';
import { OwnerSegment } from '../enums/OwnerSegment';
import { HonorariumType } from '../enums/HonorariumType';
import { ContractStatus } from '../enums/ContractStatus';
import { TaxRegime } from '../enums/TaxRegime';
import { PositionType } from '../enums/PositionType';
import { BorrowNoteType } from '../enums/BorrowNote';
import { NoteType } from '../enums/NoteType';
import { PaymentTerm } from '../enums/PaymentTerm';
import { PaymentMethod } from '../enums/PaymentMethod';
import { PartnershipType } from '../enums/PartnershipType';
import { AllocationType } from '../enums/AllocationType';
import { LeaveType } from '../enums/LeaveType';
import * as ptLocale from 'date-fns/locale/pt';
import { DatepickerOptions } from 'ng2-datepicker';
import { DropDownList } from '../../models/DropDownList.model';
import { StatusApproval } from '../enums/StatusApproval';
import { StatusRefund } from '../enums/StatusRefund';
import { GroupOrigin } from '../enums/GroupOrigin';
import { SapItemType } from '../enums/SapItemType';
import { DropDownFactory} from '../../models/billing-letter/DropDown.factory';
import {LocalStorage} from "../wrappers/LocalStorage";
import { StatusInvoice } from '../enums/StatusInvoice';
import { StatusJustification } from '../enums/StatusJustification';
import { PixKeyType } from '../enums/PixKeyType';
import { AccountingType } from '../enums/AccountingBlockType';
import { PaymentMethodPurchaseOrder } from '../enums/PaymentMethodPurchaseOrder';
import { PurchaseOrderType } from '../enums/PurchaseOrderType';
import { LaptopTransportType } from "../enums/LaptopTransportType";
import { VendorInventoryType } from '../enums/VendorInventoryType';
import { GUARDS } from '../auth/Roles';

export class CommonHelper {
    private localStorage : LocalStorage;

    getVerbs(){
        return [
            {_id:"GET",name:"Buscar"},
            {_id:"POST",name:"Criar"},
            {_id:"PUT",name:"Atualizar"},
            {_id:"DELETE",name:"Deletar"}
        ]
    }

    getConsultantVerboseFields(){
        return [
            {name:"name",verbose:"Nome"},
            {name:"email",verbose:"E-mail"},
            {name:"fcEmail",verbose:"E-mail FC"},
            {name:"cpf",verbose:"CPF"},
            {name:"begin",verbose:"Início de contrato"},
            {name:"rg",verbose:"RG"},
            {name:"bank",verbose:"Banco"},
            {name:"agency",verbose:"Agencia"},
            {name:"account",verbose:"Conta"},
            {name:"digit",verbose:"Dígito"},
            {name:"born",verbose:"Data de Nascimento"},
            {name:"responsible",verbose:"Responsável"},
            {name:"bp",verbose:"BP"},
            {name:"division",verbose:"Division"},
            {name:"subDivision",verbose:"Tipo de Serviço"},
            {name:"responsible",verbose:"Responsável"},
            {name:"contractKind",verbose:"Tipo de Contrato"},
            {name:"sex",verbose:"Sexo"},
            {name:"civilStatus",verbose:"Estado Civil"},
            {name:"motherName",verbose:"Nome da Mãe"},
            {name:"fatherName",verbose:"Nome do Pai"},
            {name:"homePhone",verbose:"Telefone"},
            {name:"cellPhone",verbose:"Celular"},
            {name:"cep",verbose:"CEP"},
            {name:"address",verbose:"Endereço"},
            {name:"number",verbose:"Número"},
            {name:"complement",verbose:"Complemento"},
            {name:"district",verbose:"Bairro"},
            {name:"city",verbose:"Cidade"},
            {name:"state",verbose:"Estado"},
            {name:"type",verbose:"Tipo"},
            {name:"name",verbose:"Nome"},
            {name:"phone",verbose:"Telefone"},
            {name:"kind",verbose:"Tipo de Contrato"},
            {name:"honorarium",verbose:"Honorário"},
            {name:"totalValue",verbose:"Valor Total"},
            {name:"paymentType",verbose:"Tipo de Pagamento"},
            {name:"mensalHours",verbose:"Horas Mensais"},
            {name:"soldHourValue",verbose:"Valor Hora Vendido"},
            {name:"hourValue",verbose:"Valor Hora"},
            {name:"benefits",verbose:"Benefícios"},
            {name:"position",verbose:"Cargo"},
            {name:"partnership",verbose:"Parceria"},
            {name:"allocation",verbose:"Alocação"},
            {name:"partnershipObs",verbose:"Observação"},
            {name:"contractStatus",verbose:"Status de contrato"},
            {name:"companyName",verbose:"Razão Social"},
            {name:"cnpj",verbose:"CNPJ"},
            {name:"taxRegime",verbose:"Regime Tributário"},
            {name:"cep",verbose:"CEP"},
            {name:"address",verbose:"Endereço"},
            {name:"number",verbose:"Número"},
            {name:"district",verbose:"Bairro"},
            {name:"city",verbose:"Cidade"},
            {name:"state",verbose:"Estado"},
            {name:"outsideSP",verbose:"Fora de SP"},
            {name:"cpom",verbose:"CPOM"},
            {name:"iss",verbose:"ISS"},
            {name:"irrf",verbose:"IRRF"},
            {name:"pcc",verbose:"PCC"},
            {name:"end",verbose:"Fim de Contrato"},
            {name:"consultantStart",verbose:"Início do Consultor"},
            {name:"consultantEnd",verbose:"Fim do Consultor"},
            {name: "customers", verbose: "Clientes"},
            {name: "keyPix", verbose: "Chave Pix"},
            {name: "excellenceCenter", verbose: "Centro de Excelência"},
            {name: "supportCenter", verbose: "Área de Suporte"},
        ]
    };

    cpfValidator(cpf) {
        let soma = 0, rest;
        if(cpf.indexOf('.') !== -1){
            cpf = cpf.replace(/\./g, "");
            cpf = cpf.replace(/\-/g, "");
        }

        if (cpf.length != 11 ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999")
            return false;

        for (let i=1; i<=9; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
        rest = (soma * 10) % 11;
        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(9, 10)) ) return false;

        soma = 0;
        for (let i = 1; i <= 10; i++)
            soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
        rest = (soma * 10) % 11;
        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(10, 11) ) ) return false;

        return true;
    }

    phoneNumberValidator(phone){
        const brazilianCellPhoneRegex = /^\(\d{2}\)\d{5}-\d{4}$/gi;
        return brazilianCellPhoneRegex.test(phone);
    }

    maskOnlyNumber(rawValue: string): RegExp[] {
        const mask = /[0-9]/;
        const validNumber = String(rawValue).length;
        const numberMask: RegExp[] = [];
        for (let i = 0; i <= validNumber; i++)
            numberMask.push(mask);
        return numberMask;
    }

    transcriptSex(sex){
        switch(sex){
            case "0": return 'Não Informado'
            case "1": return 'Feminino'
            case "2": return 'Masculino'
        }
    }

    getCurrentUser(){
        return this.localStorage.retrieve("user");
    }

    getConfigurationMaskMoney() {
        return { prefix: 'R$ ', thousands: '.', decimal: ',' };
    }

    getDatePickerOptions(): DatepickerOptions {
        return {
            minYear: 1920,
            maxYear: 2030,
            displayFormat: 'DD/MM/YYYY',
            barTitleFormat: 'MMMM YYYY',
            firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
            locale: ptLocale,
            // minDate: new Date(Date.now()), // Minimal selectable date
            // maxDate: new Date(Date.now()),  // Maximal selectable date
            barTitleIfEmpty: 'Selecione uma data',
        };
    }

    getAllStatusApproval(): StatusApproval[] {
        return [StatusApproval.AprovacaoPendente,
        StatusApproval.PagamentoPendente,
        StatusApproval.Pago,
        StatusApproval.AguardandoRacional,
        StatusApproval.PendenteRegularizacaoEmpresa]
    }

    getAllStatusRefund(): StatusRefund[] {
        return [StatusRefund.AprovacaoPendente,
        StatusRefund.AprovadoParcialmente,
        StatusRefund.PagamentoPendente,
        StatusRefund.Pago,
        StatusRefund.Reprovado,
        StatusRefund.Cancelado]
    }

    getAllPartnershipType(): PartnershipType[] {
        return [PartnershipType.Rational,
        PartnershipType.TerceirizacaoContabil,
        PartnershipType.Outros,
        PartnershipType.FiqueTranquilo]
    }

    getAllLeaveType(): LeaveType[]{
        return [LeaveType.SolicitacaoCliente,
                LeaveType.AceitouOutraProposta,
                LeaveType.ConsultorSolicitouDesligamento
        ]
    }

    getAllAllocationType(): AllocationType[] {
        return [AllocationType.Factory, AllocationType.Customer]
    }

    getAllTaxRegime(): TaxRegime[] {
        return [TaxRegime.SimplesNacional, TaxRegime.LucroPresumido]
    }

    getAllBorrowNote() : BorrowNoteType[] {
        return [BorrowNoteType.Efetivo, BorrowNoteType.NotaEmpresta]
    }

    getAllNoteType(): NoteType[] {
        return [NoteType.NotaFiscal, NoteType.NotaDebito]
    }

    getAllPaymentTerm(): PaymentTerm[] {
        return [
            PaymentTerm._10d,
            PaymentTerm._15d,
            PaymentTerm._15d30d,
            PaymentTerm._15d30d45d,
            PaymentTerm._30d,
            PaymentTerm._30d60d,
            PaymentTerm._30d60d90d,
            PaymentTerm._30d60d90d120d,
            PaymentTerm._45d,
            PaymentTerm._45d90d,
            PaymentTerm._45d90d135d,
            PaymentTerm._45d90d135d180d,
            PaymentTerm._60d,
            PaymentTerm._90d,
            PaymentTerm._aVista,
            PaymentTerm._aVista15d,
            PaymentTerm._aVista15d30d,
            PaymentTerm._aVista30d,
            PaymentTerm._aVista30d60d,
            PaymentTerm._aVista45d,
            PaymentTerm._aVista45d90d,
        ]
    }

    getAllPaymentMethod(): PaymentMethod[] {
        return [
            PaymentMethod.ItauBoleto,
            PaymentMethod.ItauTransferencia,
            PaymentMethod.ItauPix
        ]
    }

    getAllPaymentMethodPurchaseOrder(): PaymentMethodPurchaseOrder[] {
        return [
            PaymentMethodPurchaseOrder.Boleto,
            PaymentMethodPurchaseOrder.Transferencia,
            PaymentMethodPurchaseOrder.CartaoCredito,
        ]
    }

    getAllPixTypes(): PixKeyType[]{
        return [
            PixKeyType.default,
            PixKeyType.phone,
            PixKeyType.email,
            PixKeyType.cpf_cnpj,
            PixKeyType.randomized
        ]
    }

    getAllPositionType(): PositionType[] {
        return [
            PositionType.AnalistaTeste,
            PositionType.Desenvolvedor,
            PositionType.GerenteProjeto,
            PositionType.WebDesign,
            PositionType.AnalistaInfraestrutura,
            PositionType.AnalistaSuporte,
            PositionType.ScrumMaster,
            PositionType.AnalistaDBASenior,
            PositionType.DBAJunior,
            PositionType.AdministradorBD,
            PositionType.AnalistaRede,
            PositionType.AnalistaNegocio,
            PositionType.LiderTecnico,
            PositionType.AnalistaBI,
            PositionType.GestorFraude,
            PositionType.GerenteRelacionamento,
            PositionType.AnalistaRequisitos,
            PositionType.ArquitetoSistemas,
            PositionType.AnalistaFuncional,
            PositionType.AnalistaGovernanca,
            PositionType.AnalistaAlmPleno,
            PositionType.PRODUCTOWNER,
            PositionType.AnalistaSistema,
            PositionType.AnalistaProducao,
            PositionType.SystemConfigurationManager,
            PositionType.LiderInfraestrutura,
            PositionType.AnalistaDadosPleno,
            PositionType.EspecialistaUX,
            PositionType.AnalistaBD,
            PositionType.AnalistaQualidade,
            PositionType.InsideSales,
            PositionType.ConsultorAzure,
            PositionType.Comercial,
            PositionType.AgileCoachSenior,
            PositionType.Head,
            PositionType.LiderMarketing,
            PositionType.DevOps,
            PositionType.LiderQA,
            PositionType.SegurancaInformacao,
            PositionType.CientistaDados,
            PositionType.AnalistaSEO,
            PositionType.Redatora,
            PositionType.AnalistaMarketingProduto
        ];
    }

    getAllBankName() {
        return [
            { 'name': 'Banco do Brasil', 'number': '001' },
            { 'name': 'Caixa Econômica Federal', 'number': '104' },
            { 'name': 'Citbank', 'number': '745' },
            { 'name': 'Banco Safra', 'number': '422' },
            { 'name': 'Santander', 'number': '033' },
            { 'name': 'Bradesco', 'number': '237' },
            { 'name': 'Itaú', 'number': '341' },
            { 'name': 'Banco Votorantim', 'number': '655' },
            { 'name': 'Banco Inter', 'number': '077' },
            { 'name': 'Sicoob', 'number': '756' },
            { 'name': 'Nubank', 'number': '260' },
            { 'name': 'Original', 'number': '212' },
            { 'name': 'Stone', 'number': '197' },
            // { 'name': 'Neon', 'number': '735' },
            // { 'name': 'Agibank', 'number': '121' },
            // { 'name': 'Cetelem', 'number': '739' },
            // { 'name': 'Sicredi', 'number': '748' },
            // { 'name': 'Pagseguro', 'number': '290' },
            // { 'name': 'Banco BS2', 'number': '218' },
            // { 'name': 'Banco C6', 'number': '336' }
        ];
    }

    transcriptBank(bank: any) {
        switch (bank) {
            case '001':
                return 'Banco do Brasil';
            case '104':
                return 'Caixa Econômica Federal';
            case '745':
                return 'Citbank';
            case '422':
                return 'Banco Safra';
            case '033':
                return 'Santander';
            case '237':
                return 'Bradesco';
            case '341':
                return 'Itaú';
            case '735':
                return 'Neon';
            case '212':
                return 'Original';
            case '756':
                return 'Sicoob';
            case '077':
                return 'Banco Inter';
            case '655':
                return 'Banco Votorantim';
            case '260':
                return 'Nubank';
            case '739':
                return 'Cetelem';
            case '121':
                return 'Agibank';
            case '197':
                return 'Stone';
            case '748':
                return 'Sicredi';
            case '290':
                return 'Pagseguro';
            case '218':
                return 'Banco BS2';
            case '336':
                return 'Banco C6';
            default:
                return "";
        }
    }

    getAllContractStatus(): ContractStatus[] {
        return [ContractStatus.AssinaturaConsultor,
        ContractStatus.AssinaturaOmnik,
        ContractStatus.Concluido,
        ContractStatus.EmElaboracao,
        ContractStatus.Verificar];
    }

    getAllContractClassification(): ContractClassification[] {
        return [ContractClassification.Trainee,
        ContractClassification.Junior,
        ContractClassification.Pleno,
        ContractClassification.Senior];
    }

    getAllHonorariumType(): HonorariumType[] {
        return [HonorariumType.HoraAberta,
        HonorariumType.HoraFechada];
    }

    getAllPaymentType(): PaymentType[] {
        return [PaymentType.OP,
        PaymentType.TED,
        PaymentType.TranferenciaItau,
        PaymentType.Cheque,
        PaymentType.PIX];
    }

    getAllContactType(): ContactType[] {
        return [ContactType.Conjuge,
        ContactType.Mae,
        ContactType.Outros,
        ContactType.Pai,
        ContactType.TiaOuTio];
    }

    getAllContractType(): ContractType[] {
        return [
            ContractType.CLT,
            ContractType.PJ,
            ContractType.Estagiario,
            ContractType.Outros];
    }

    getAllCivilStatus(): CivilStatus[] {
        return [
            CivilStatus.Solteiro,
            CivilStatus.Casado,
            CivilStatus.Viuvo,
            CivilStatus.Divorciado];
    }

    getAllOwnerSegmnet(division): OwnerSegment[] {
        switch(division){
            case 1:
                return [
                    OwnerSegment.EXPONENTIAL_NICOLE,
                    OwnerSegment.EXPONENTIAL_LYSSA,
                ]
            case 3:
                return [
                    OwnerSegment.OMNI_FINANCE,
                    OwnerSegment.OMNI_PISANE,
                    OwnerSegment.OMNI_LOHAIN,
                    OwnerSegment.OMNI_MAZZINI,
                ]
            case 5:
                return [
                    OwnerSegment.FCNUVEM_LOUSADA,
                    OwnerSegment.FCNUVEM_TIAGO,
                ]
            default:
                return []
        }
    }

    transcriptInternalRole(role: any) {
        switch (role) {
            case GUARDS.ADMINISTRATIVE:
                return "Administrativo";
            case GUARDS.ADMIN:
                return "Admin";
            case GUARDS.ADMINISTRATIVE_2:
                return "Administrativo 2";
            case GUARDS.BILLSRECEIVE:
                return "Contas a receber";
            case GUARDS.BUSINESSPARTNER:
                return "Business Partner";
            case GUARDS.COMMERCIAL:
                return "Comercial";
            case GUARDS.CONTROLLERSHIP:
                return "Controladoria";
            case GUARDS.DP:
                return "DP";
            case GUARDS.FINANCES:
                return "Contas a pagar";
            case GUARDS.GOVERNANCE:
                return "Governança";
            case GUARDS.INFRA:
                return "Infra";
            case GUARDS.JUDICIARY:
                return "Jurídico";
            case GUARDS.MANAGER:
                return "Gestor";
            case GUARDS.RS:
                return "RS";
            case GUARDS.TECHMANAGEMENT:
                return "Gestor Técnico";
            case GUARDS.PMO:
                return "Gestor de Projeto";
            default:
                return "Sistema";
        }
    }

    transcriptOwnerSegmnet(ownerSegment: OwnerSegment) {
        switch(ownerSegment){
            case OwnerSegment.FCNUVEM_LOUSADA:
                return "Leandro Lousada";
            case OwnerSegment.FCNUVEM_TIAGO:
                return "Tiago";
            case OwnerSegment.OMNI_FINANCE:
                return "Finance";
            case OwnerSegment.OMNI_PISANE:
                return "Gustavo Pisane";
            case OwnerSegment.OMNI_LOHAIN:
                return "Lohain";
            case OwnerSegment.OMNI_MAZZINI:
                return "Marcelo Mazzini";
            case OwnerSegment.EXPONENTIAL_NICOLE:
                return "Nicole"
            case OwnerSegment.EXPONENTIAL_LYSSA:
                return "Lyssa"
        }
    }

    transcriptStatusApproval(statusApproval: StatusApproval) {
        switch (statusApproval) {
            case StatusApproval.AprovacaoPendente:
                return "Aprovação Pendente";
            case StatusApproval.PagamentoPendente:
                return "Pagamento Pendente";
            case StatusApproval.Pago:
                return "Pago";
            case StatusApproval.AguardandoRacional:
                return "Aguardando Racional";
            case StatusApproval.PendenteRegularizacaoEmpresa:
                return "Pendente Regularização de Empresa";
            default:
                return "";
        }
    }

    transcriptStatusRefund(statusRefund: StatusRefund) {
        switch (statusRefund) {
            case StatusRefund.AprovacaoPendente:
                return "Aprovação Pendente";
            case StatusRefund.PagamentoPendente:
                return "Pagamento Pendente";
            case StatusRefund.Pago:
                return "Pago";
            case StatusRefund.Reprovado:
                return "Reprovado";
            case StatusRefund.Cancelado:
                return "Cancelado";
            case StatusRefund.AprovadoParcialmente:
                return "Aprovado Parcialmente";
            default:
                return "";
        }
    }

    transcriptBillingStatus(status?){
        let list = [
            "Em aberto",
            "Liberado Omnik",
            "Liberado Cliente",
            "Aguardando Pagamento",
            "Pago",
            "Cancelado",
            "Perda contábil"
        ];
        return list[status]?list[status]:"-";
    }

    transcriptTaxRegime(taxRegime: TaxRegime) {
        switch (taxRegime) {
            case TaxRegime.SimplesNacional:
                return "Simples Nacional";
            case TaxRegime.LucroPresumido:
                return "Lucro Presumido";
            default:
                return "";
        }
    }

    transcriptPurchaseOrderType(type: PurchaseOrderType) {
        switch (type) {
            case PurchaseOrderType.PurchaseOrder:
                return "Pedidos de Compras";
            case PurchaseOrderType.PurchaseOrderUmbrella:
                    return "Pedidos Guarda Chuva";
            default:
                return "";
        }
    }

    transcriptPositionType(positionType: PositionType) {
        switch (positionType) {
            case PositionType.AnalistaTeste:
                return "Analista de teste";
            case PositionType.Desenvolvedor:
                return "Desenvolvedor";
            case PositionType.GerenteProjeto:
                return "Gerente de Projeto/PO";
            case PositionType.WebDesign:
                return "Web Design";
            case PositionType.AnalistaInfraestrutura:
                return "Analista de Infraestrutura";
            case PositionType.AnalistaSuporte:
                return "Analista de Suporte";
            case PositionType.ScrumMaster:
                return "Scrum Master";
            case PositionType.AnalistaDBASenior:
                return "Analista DBA Sênior";
            case PositionType.DBAJunior:
                return "DBA Júnior";
            case PositionType.AdministradorBD:
                return "Administrador de banco de dados (DBA)";
            case PositionType.AnalistaRede:
                return "Analista de Rede";
            case PositionType.AnalistaNegocio:
                return "Analista de Negócio";
            case PositionType.LiderTecnico:
                return "Líder Técnico/Tech Leader";
            case PositionType.AnalistaBI:
                return "Analista BI";
            case PositionType.GestorFraude:
                return "Gestor de Fraude";
            case PositionType.GerenteRelacionamento:
                return "Gerente de Relacionamento";
            case PositionType.AnalistaRequisitos:
                return "Analista de Requisitos";
            case PositionType.ArquitetoSistemas:
                return "Arquiteto de Sistemas";
            case PositionType.AnalistaFuncional:
                return "Analista Funcional";
            case PositionType.AnalistaGovernanca:
                return "Analista de Governança";
            case PositionType.AnalistaAlmPleno:
                return "Analista Alm Pleno";
            case PositionType.PRODUCTOWNER:
                return "PRODUCT OWNER";
            case PositionType.AnalistaSistema:
                return "Analista de Sistema";
            case PositionType.AnalistaProducao:
                return "Analista de Produção";
            case PositionType.SystemConfigurationManager:
                return "System Configuration Manager";
            case PositionType.LiderInfraestrutura:
                return "Líder de Infraestrutura";
            case PositionType.AnalistaDadosPleno:
                return "Analista de Dados Pleno";
            case PositionType.EspecialistaUX:
                return "Especialista UX";
            case PositionType.AnalistaBD:
                return "Analista de Bancos de Dados";
            case PositionType.AnalistaQualidade:
                return "Analista de Qualidade";
            case PositionType.InsideSales:
                return "Inside Sales";
            case PositionType.ConsultorAzure:
                return "Consultor Azure";
            case PositionType.Comercial:
                return "Comercial";
            case PositionType.AgileCoachSenior:
                return "Agile Coach Senior";
            case PositionType.Head:
                return "Head";
            case PositionType.LiderMarketing:
                return "Líder de Marketing";
            case PositionType.DevOps:
                return "DevOps";
            case PositionType.LiderQA:
                return "Líder de QA";
            case PositionType.SegurancaInformacao:
                return "Segurança da Informação";
            case PositionType.CientistaDados:
                return "Cientista de Dados";
            case PositionType.AnalistaSEO:
                return "Analista SEO";
            case PositionType.Redatora:
                return "Redatora";
            case PositionType.AnalistaMarketingProduto:
                return "Analista de Marketing de Produto";
            default:
                return "";
        }
    }

    transcriptBorrowNote(borrowNote: BorrowNoteType) {
        switch (borrowNote) {
            case BorrowNoteType.Efetivo:
                return "Efetivo";
            case BorrowNoteType.NotaEmpresta:
                return "Nota Emprestada";
            default:
                return "";
        }
    }

    transcriptNoteType(noteType: NoteType) {
        switch (Number(noteType)) {
            case NoteType.NotaFiscal:
                return "Nota Fiscal";
            case NoteType.NotaDebito:
                return "Nota de Débito";
            default:
                return "";
        }
    }

    transcriptPaymentTerm(paymentTerm: PaymentTerm) {
        switch (paymentTerm) {
            case PaymentTerm._10d:
                return "10 dias";
            case PaymentTerm._15d:
                return "15 dias";
            case PaymentTerm._15d30d:
                return "15 e 30 dias";
            case PaymentTerm._15d30d45d:
                return "15, 30 e 45 dias";
            case PaymentTerm._30d:
                return "30 dias";
            case PaymentTerm._30d60d:
                return "30 e 60 dias";
            case PaymentTerm._30d60d90d:
                return "30, 60 e 90 dias";
            case PaymentTerm._30d60d90d120d:
                return "30, 60, 90 e 120 dias";
            case PaymentTerm._45d:
                return "45 dias";
            case PaymentTerm._45d90d:
                return "45 e 90 dias";
            case PaymentTerm._45d90d135d:
                return "45, 90 e 135 dias";
            case PaymentTerm._45d90d135d180d:
                return "45, 90, 135 e 180 dias";
            case PaymentTerm._60d:
                return "60 dias";
            case PaymentTerm._90d:
                return "90 dias";
            case PaymentTerm._aVista:
                return "À vista";
            case PaymentTerm._aVista15d:
                return "À vista e 15 dias";
            case PaymentTerm._aVista15d30d:
                return "À vista, 15 e 30 dias";
            case PaymentTerm._aVista30d:
                return "À vista e 30 dias";
            case PaymentTerm._aVista30d60d:
                return "À vista, 30 e 60 dias";
            case PaymentTerm._aVista45d:
                return "À vista e 45 dias";
            case PaymentTerm._aVista45d90d:
                return "À vista, 45 e 90 dias";
            default:
                return "";
        }
    }

    transcriptPaymentMethod(paymentMethod: PaymentMethod) {
        switch (paymentMethod) {
            case PaymentMethod.ItauBoleto:
                return "Banco Itau - C/C:09432-7 - Boleto";
            case PaymentMethod.ItauTransferencia:
                return "Banco Itau - C/C:09432-7 - Transferência, DOC e TED";
            case PaymentMethod.ItauPix:
                return "Banco Itau - C/C:09432-7 - Pix";
            default:
                return "";
        }
    }

    transcriptPaymentMethodPurchaseOrder(paymentMethodPurchaseOrder: PaymentMethodPurchaseOrder) {
        switch (paymentMethodPurchaseOrder) {
            case PaymentMethodPurchaseOrder.Boleto:
                return "Boleto";
            case PaymentMethodPurchaseOrder.Transferencia:
                return "Transferência";
            case PaymentMethodPurchaseOrder.CartaoCredito:
                return "Cartão de Crédito";
            default:
                return "";
        }
    }

    transcriptPixType(pixKeyType: PixKeyType){
        switch (pixKeyType) {
            case PixKeyType.default:
                return "Selecione uma chave"
            case PixKeyType.phone:
                return "Telefone"
            case PixKeyType.email:
                return "Email"
            case PixKeyType.cpf_cnpj:
                return "CPF/CNPJ"
            case PixKeyType.randomized:
                return "Aleatória"
            default:
                return "";
        }
    }

    transcriptPartnershipType(partnershipType: PartnershipType) {
        switch (partnershipType) {
            case PartnershipType.Rational:
                return "Rational";
            case PartnershipType.TerceirizacaoContabil:
                return "Terceirização Contábil";
            case PartnershipType.Outros:
                return "Outros";
            case PartnershipType.FiqueTranquilo:
                return "Fique Tranquilo";
            default:
                return "";
        }
    }

    transcriptAllocationType(allocationType: AllocationType) {
        switch (allocationType) {
            case AllocationType.Factory:
                return "Fábrica";
            case AllocationType.Customer:
                return "Cliente";
            default:
                return "";
        }
    }


    transcriptContractStatus(contractStatus: ContractStatus) {
        switch (contractStatus) {
            case ContractStatus.AssinaturaConsultor:
                return "Assinatura Consultor";
            case ContractStatus.AssinaturaOmnik:
                return "Assinatura Omnik";
            case ContractStatus.Concluido:
                return "Concluído";
            case ContractStatus.EmElaboracao:
                return "Em Elaboração";
            case ContractStatus.Verificar:
                return "Verificar";
            default:
                return "";
        }
    }

    transcriptContractClassification(contractClassification: ContractClassification) {
        switch (contractClassification) {
            case ContractClassification.Trainee:
                return "Trainee";
            case ContractClassification.Junior:
                return "Júnior";
            case ContractClassification.Pleno:
                return "Pleno";
            case ContractClassification.Senior:
                return "Sênior";
            default:
                return "";
        }
    }

    transcriptAdditiveType(additiveType: Number) {
        switch (additiveType) {
            case 1:
                return "Reajuste de valor";
            case 2:
                return "Renovação de contrato";
            case 3:
                return "Alteração de razão social ou CNPJ";
            default:
                return "";
        }
    }

    transcriptHonorariumType(honorariumType: HonorariumType) {
        switch (honorariumType) {
            case HonorariumType.HoraAberta:
                return "Hora Aberta";
            case HonorariumType.HoraFechada:
                return "Hora Fechada";
            default:
                return "";
        }
    }

    transcriptVerb(verb) {
        switch (verb) {
            case "GET":
                return "Buscar";
            case "POST":
                return "Criar";
            case "PUT":
                return "Atualizar";
            case "DELETE":
                return "Deletar";
            default:
                return "";
        }
    }

    transcriptPaymentType(paymentType: PaymentType) {
        switch (paymentType) {
            case PaymentType.OP:
                return "OP";
            case PaymentType.TED:
                return "TED";
            case PaymentType.TranferenciaItau:
                return "Transferência Itaú";
            case PaymentType.Cheque:
                return "Cheque";
            case PaymentType.PIX:
                return "PIX";
            default:
                return "";
        }
    }

    transcriptLeaveType(leaveType: LeaveType) {
        switch (leaveType) {
            case LeaveType.SolicitacaoCliente:
                return 'Solicitação do cliente';
            case LeaveType.AceitouOutraProposta:
                return 'Aceitou outra oportunidade';
            case LeaveType.ConsultorSolicitouDesligamento:
                return 'Questões Pessoais';
            case LeaveType.EndOfContract:
                return 'Fim de Contrato';
            case LeaveType.Others:
                return 'Outros';
            case LeaveType.IncompatibleProfile:
                return 'Perfil incompatibilizado';
            case LeaveType.Ethics:
                return 'Postura (Comportamento, ética, similares)';
            case LeaveType.Restructuring:
                return 'Restruturação';
            case LeaveType.UnsatisfiedWithClientOrProject:
                return 'Insatisfeito com o Cliente/Projeto';
            case LeaveType.InternationalOpportunity:
                return 'Oportunidade Internacional';
            case LeaveType.NationalPropositionChallenge:
                return 'Proposta Nacional (Desafio)';
            case LeaveType.PoorPerformance:
                return 'Baixa Performance';
            default:
                return "";
        }
    }

    transcriptContactType(contactType: ContactType) {
        switch (contactType) {
            case ContactType.Outros:
                return "Outros";
            case ContactType.Pai:
                return "Pai";
            case ContactType.Mae:
                return "Mãe";
            case ContactType.Conjuge:
                return "Cônjuge";
            case ContactType.TiaOuTio:
                return "Tia(o)";
            default:
                return "";
        }
    }

    transcriptContractType(contractType: ContractType) {
        switch (contractType) {
            case ContractType.PJ:
                return "PJ";
            case ContractType.CLT:
                return "CLT";
            case ContractType.Estagiario:
                return "Estagiário";
            case ContractType.Outros:
                return "Outros";
            default:
                return "";
        }
    }

    transcriptActive(active) {
        switch (active) {
            case true:
                return "Ativo";
            case false:
                return "Inativo";
            case undefined:
                return "Inativo";
            default:
                return "";
        }
    }

    transcriptDivisionGroup(groupDivision: GroupDivision) {
        switch (groupDivision) {
            case GroupDivision.Omnik:
                return "Omnik";
            default:
                return "Não Informado";
        }
    }

    getSubDivisionsCodeAndName() {
        return [
            {
                code: 'D01S01',
                name: 'SQUAD'
            },
            {
                code: 'D01S02',
                name: 'SUSTENTAÇÃO'
            },
            {
                code: 'D01S03',
                name: 'RECORRENCIA'
            },
            {
                code: 'D01S04',
                name: 'SETUP'
            }
        ]
    }

    transcriptOriginGroup(groupOrigin: GroupOrigin) {
        switch (groupOrigin) {
            case GroupOrigin.Marketing:
                return "Marketing";
            case GroupOrigin.Vendas:
                return "Vendas";
            case GroupOrigin.Parceiro:
                return "Parceiro";
            case GroupOrigin.Indicacao:
                return "Indicação";
            default:
                return groupOrigin;
        }
    }

    transcriptReadjustmentQuoeficientGroup(groupReadjustmentQuoeficient: GroupReadjustmentQuoeficient) {
        switch (groupReadjustmentQuoeficient) {

            case GroupReadjustmentQuoeficient.IgpDiFgv:
                return "IGP-DI (FGV)";
            case GroupReadjustmentQuoeficient.IgpMFgv:
                return "IGP-M (FGV)";
            case GroupReadjustmentQuoeficient.Inpc:
                return "IPC (Fipe)";
            case GroupReadjustmentQuoeficient.Ipc:
                return "INPC (IBGE)";
            case GroupReadjustmentQuoeficient.Ipca:
                return "IPCA (IBGE)";
            case GroupReadjustmentQuoeficient.Aditivo:
                return "Aditivo";
            case GroupReadjustmentQuoeficient.NotApplicable:
                return "NÃO APLICÁVEL";
            default:
                return groupReadjustmentQuoeficient;
        }
    }

    getAllFinesAndInterests(): FinesAndInterests[] {
        return[
            FinesAndInterests.Fees,
            FinesAndInterests.Fine,
            FinesAndInterests.FinesAndInterest,
            FinesAndInterests.None,
        ];
    }

    getAllInternalRoles() {
        return [
            //GUARDS.ADMIN,
            GUARDS.ADMINISTRATIVE,
            GUARDS.ADMINISTRATIVE_2,
            GUARDS.BILLSRECEIVE,
            GUARDS.BUSINESSPARTNER,
            GUARDS.COMMERCIAL,
            GUARDS.CONTROLLERSHIP,
            GUARDS.DP,
            GUARDS.FINANCES,
            GUARDS.GOVERNANCE,
            GUARDS.INFRA,
            GUARDS.JUDICIARY,
            GUARDS.MANAGER,
            GUARDS.RS
        ];
    }

    transcriptFinesAndInterests(finesAndInterests: FinesAndInterests) {
        switch (finesAndInterests) {

            case FinesAndInterests.Fees:
                return "Possui Juros";
            case FinesAndInterests.Fine:
                return "Possui Multa";
            case FinesAndInterests.FinesAndInterest:
                return "Possui Juros e Multa";
            case FinesAndInterests.None:
                return "Não possui Juros e Multa";
            default:
                return FinesAndInterests;
        }
    }

    transcriptCivilStatus(civilStatus: CivilStatus) {
        switch (civilStatus) {
            case CivilStatus.Solteiro:
                return "Solteiro(a)";
            case CivilStatus.Casado:
                return "Casado(a)";
            case CivilStatus.Divorciado:
                return "Divorciado(a)";
            case CivilStatus.Viuvo:
                return "Viúvo(a)";
            default:
                return "";
        }
    }

    transcriptSapItemType(sapItemType: SapItemType) {
        switch (sapItemType) {
            case SapItemType.CnaeBilling:
                return "CNAE de carta de faturamento";
            case SapItemType.CnaeConsultant:
                return "CNAE de consultor";
            case SapItemType.ItemPurchaseOrder:
                return "Item de pedido de compra";
            default:
                return "";
        }
    }

    getAllPurchaseOrderType(): PurchaseOrderType[] {
        return [
            PurchaseOrderType.PurchaseOrder,
            PurchaseOrderType.PurchaseOrderUmbrella
        ];
    }

    getAllGroups(): GroupDivision[] {
        return [
            GroupDivision.Omnik
        ];
    }


    getAllOriginGroups(): GroupOrigin[] {
        return [
            GroupOrigin.Marketing,
            GroupOrigin.Vendas,
            GroupOrigin.Parceiro,
            GroupOrigin.Indicacao];
    }

    getAllReadjustmentQuoeficientGroups():GroupReadjustmentQuoeficient[]{
        return[
            GroupReadjustmentQuoeficient.IgpDiFgv,
            GroupReadjustmentQuoeficient.IgpMFgv,
            GroupReadjustmentQuoeficient.Ipc,
            GroupReadjustmentQuoeficient.Inpc,
            GroupReadjustmentQuoeficient.Ipca,
            GroupReadjustmentQuoeficient.Aditivo,
            GroupReadjustmentQuoeficient.NotApplicable
        ];
    }

    getAllStates() {
        return [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO'];
    }

    getAllSapItemType(): SapItemType[] {
        return [
            SapItemType.CnaeBilling,
            SapItemType.CnaeConsultant,
            SapItemType.ItemPurchaseOrder
        ]
    }

    listLastYears() {
        let currentYear = new Date().getFullYear();
        let firstYear = 2019;
        let lastYear = currentYear + 2;
        let years: number[] = new Array<number>();

        for (firstYear; firstYear <= lastYear; firstYear++)
            years.push(firstYear);

        return years.reverse();
    }

    listAllMonths() {
        return [{ number: 0, name: 'Janeiro' },
        { number: 1, name: 'Fevereiro' },
        { number: 2, name: 'Março' },
        { number: 3, name: 'Abril' },
        { number: 4, name: 'Maio' },
        { number: 5, name: 'Junho' },
        { number: 6, name: 'Julho' },
        { number: 7, name: 'Agosto' },
        { number: 8, name: 'Setembro' },
        { number: 9, name: 'Outubro' },
        { number: 10, name: 'Novembro' },
        { number: 11, name: 'Dezembro' }]
    }

    multiSelectMonths(){
        return [{ _id: '0', name: 'Janeiro' },
        { _id: '1', name: 'Fevereiro' },
        { _id: '2', name: 'Março' },
        { _id: '3', name: 'Abril' },
        { _id: '4', name: 'Maio' },
        { _id: '5', name: 'Junho' },
        { _id: '6', name: 'Julho' },
        { _id: '7', name: 'Agosto' },
        { _id: '8', name: 'Setembro' },
        { _id: '9', name: 'Outubro' },
        { _id: '10', name: 'Novembro' },
        { _id: '11', name: 'Dezembro' }]
    }

    formatMonth(value:number){
        let months = [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro'
        ];

        return months[value]?months[value]:"-";
    }

     getDropDownListItemsEnum(source: any, type: string) {
        var ddl = new Array<DropDownList>();
        for (let i of source) {
            let itemDdl = new DropDownList();
            itemDdl.id = i;
            if (type === "StatusApproval")
                itemDdl.itemName = this.transcriptStatusApproval(i);
            if (type === "StatusRefund")
                itemDdl.itemName = this.transcriptStatusRefund(i);
            if (type === "StatusInvoice")
                itemDdl.itemName = this.transcriptStatusInvoice(i);
            if (type === "GroupDivision")
                itemDdl.itemName = this.transcriptDivisionGroup(i);
            if (type === "Contract")
                itemDdl.itemName = this.transcriptContractType(i);
            if (type === "VendorInventory")
                itemDdl.itemName = this.transcriptVendorInventoryType(i);
            if (type === "PurchaseOrderType")
                itemDdl.itemName = this.transcriptPurchaseOrderType(i);
            ddl.push(itemDdl);
        }

        return ddl;
    }


    getDropDownListItems(source: any, descriptionId: string, descriptionName: string, params = []) {
        var ddl = new Array<DropDownList>();

        for (let i of source) {
            let itemDdl = new DropDownList();
            itemDdl.id = descriptionId != null ? i[descriptionId] : i;
            itemDdl.itemName = descriptionName != null ? i[descriptionName] : i;
            if(params.length > 0){
                params.forEach(param => itemDdl[param]= i[param]? i[param]:null);
            }
            ddl.push(itemDdl);
        }
        return ddl;
    }

    getDropDownListConsultant(source: any, descriptionId?: string, descriptionName?: string, descriptionKind?:string, descriptionDiv?:string, descriptionActive?:string, descriptionExcellenceCenter?: string) {
        var ddl = new Array<any>();

        for (let i of source) {
            let itemDdl = {}
            itemDdl['id'] = descriptionId != null ? i[descriptionId] : i;
            itemDdl['itemName'] = descriptionName != null ? i[descriptionName] : i;
            itemDdl['kind'] = descriptionKind != null ? this.transcriptContractType(i.contract.kind): i;
            itemDdl['division'] = descriptionDiv != null ? this.transcriptDivisionGroup(i.division): i;
            itemDdl['active'] = descriptionActive != null? this.transcriptActive(i[descriptionActive]) : i;
            itemDdl['excellenceCenter'] = descriptionExcellenceCenter != null ? (i.excellenceCenter ? i.excellenceCenter._id : i) : i;
            ddl.push(itemDdl);
        }
        return ddl;
    }

    getDropDown(source: any) {
        const factory:DropDownFactory = new DropDownFactory();

        return source.map(item => {
            return {
                id: item._id ? item._id : null,
                itemName: item.name ? item.name : null
            };
        });
    }

    getDropDownSettings(
        singleSelection: boolean,
        text: string,
        enableCheckAll:boolean,
        selectAllText: string,
        unSelectAllText: string,
        enableSearchFilter: boolean,
        groupBy: string,
        classes: string,
        disabled?: boolean,
        badgeShowLimit?:Number,
        searchPlaceholderText?: string,
        enableFilterSelectAll?: boolean,
        ) {
        return {
            singleSelection: singleSelection,
            text: text,
            enableCheckAll:enableCheckAll,
            selectAllText: selectAllText,
            unSelectAllText: unSelectAllText,
            enableSearchFilter: enableSearchFilter,
            groupBy: groupBy,
            classes: classes,
            maxHeight:200,
            disabled:disabled?disabled:false,
            badgeShowLimit: badgeShowLimit ? badgeShowLimit : 5,
            searchPlaceholderText: searchPlaceholderText ? searchPlaceholderText : '',
            enableFilterSelectAll: enableFilterSelectAll ? enableFilterSelectAll : false
        };
    }

    transcriptStatusInvoice(statusInvoice: StatusInvoice) {
        switch (statusInvoice) {
            case StatusInvoice.Received_Processing:
                return "Recebido/Processando";
            case StatusInvoice.Approved:
                return "Aprovada"
            case StatusInvoice.Denied:
                return "Reprovada"
            default:
                return '';
        }
    };

    getStatusInvoice(): StatusInvoice[] {
        return [
            StatusInvoice.Received_Processing,
            StatusInvoice.Approved,
            StatusInvoice.Denied
        ];
    };

    getJustificationInvoice(): StatusJustification[] {
        return [
            StatusJustification.CNAE,
            StatusJustification.Divergent_value,
            StatusJustification.Others
        ]
    };

    transcriptJustification(statusJustify: StatusJustification) {
        switch (statusJustify) {
            case StatusJustification.CNAE:
                return "CNAE";
            case StatusJustification.Divergent_value:
                return "Valor divergente"
            case StatusJustification.Others:
                return "Outros"
            default:
                return '';
        };
    };

    transcriptAccountingType(type: AccountingType) {
        switch(type) {
            case AccountingType.BillingLetter:
                return 'CARTA DE FATURAMENTO';
            case AccountingType.Approval:
                return 'APROVAÇÃO DE CONSULTOR'
            case AccountingType.Refund:
                return 'REEMBOLSO'
            case AccountingType.PurchaseOrder:
                return 'PEDIDOS DE COMPRA'
            default:
                return ''
        }
    }

    getAccountingTypes() {
        return [
            {
                type: AccountingType.BillingLetter,
                name: 'CARTA DE FATURAMENTO'
            },
            {
                type: AccountingType.Approval,
                name: 'APROVAÇÃO DE CONSULTOR'
            },
            {
                type: AccountingType.Refund,
                name: 'REEMBOLSO'
            },
            {
                type: AccountingType.PurchaseOrder,
                name: 'PEDIDOS DE COMPRA'
            },
        ]
    }

    getLaptopTransportType() {
        return [
            {
                code: 1,
                description: 'Equipamento será enviado pelo Consultor(a)'
            },
            {
                code: 2,
                description: 'Equipamento será retirado via Loggi'
            },
            {
                code: 3,
                description: 'Equipamento será retirado via DHL'
            }
        ]
    }

    transcriptLapTopTransportType(transportCode: LaptopTransportType) {
        switch (transportCode) {
            case LaptopTransportType.Consultant:
                return 'Equipamento será enviado pelo Consultor(a)'
            case LaptopTransportType.Loggi:
                return 'Equipamento será retirado via Loggi'
            case LaptopTransportType.Dhl:
                return 'Equipamento será retirado via DHL'
            default:
                return ''
        }
    }

    getDayPeriod() {
        return [
            'Manhã',
            'Tarde',
            'Horário comercial'
        ]
    }

    transcriptVendorInventoryType(id: string){
        const map = {
            [VendorInventoryType.PJ]: "PJ",
            [VendorInventoryType.Vendor]: "Fornecedor"
        };

        if (!map[id])
            return '-';

        return map[id];
    }

    getAllVendorInventoryTypes(){
        return [
            VendorInventoryType.PJ,
            VendorInventoryType.Vendor
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/CommonHelper.ts